const idCreator = (headingTitle) => {
  if (!headingTitle || typeof headingTitle !== 'string') return '';
  return headingTitle.replace(/[^a-z0-9]/gi, '-').toLowerCase();
};

export default idCreator;
